import { d as r } from "../internals/define-built-in.js";
import { e as t } from "../internals/error-to-string.js";
var o = Error.prototype;
o.toString !== t && r(o, "toString", t);